(function () {
  'use strict';

  angular.module('sempraWebapp').factory('userActions', userActionsFactory);

  /** @ngInject */
  function userActionsFactory(api, $q, dispatcher, ActionTypesEnum, $translate, sessionData) {
    return {
      signIn: signIn,
      updateUserInfo : updateUserInfo,
      changeUserRole : changeUserRole,
      changePassword : changePassword,
      getAllCompanyUsers : getAllCompanyUsers,
      deleteUser : deleteUser,
      addNewUser : addNewUser,
      forgotPassword : forgotPassword,
      activateAccount : activateAccount,
      deleteHistory: deleteHistory,
      getCompanyDetails: getCompanyDetails,
      getRegionById: getRegionById,
      getOrganizationUsers: getOrganizationUsers,
      deleteOrganizationUser: deleteOrganizationUser,
      getOrganizationUserById: getOrganizationUserById,
      refreshToken: refreshToken,
      getReleaseNotes: getReleaseNotes,
      resendVerificationMail: resendVerificationMail,
      resetPassword: resetPassword,
      getTermsOfServiceDocument: getTermsOfServiceDocument,
      acceptTermsOfServiceDocument: acceptTermsOfServiceDocument
    };

    function signIn(username, password) {
      var deferred = $q.defer();
      api.signIn(username, password).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function updateUserInfo(data) {
      var deferred = $q.defer();
      api.updateUserInfo(data).then(function () {
        // save to local storage
        sessionData.setValue('firstName', data.firstName);
        sessionData.setValue('lastName', data.lastName);
        // dispatch message
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('UPDATE_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function changeUserRole(data) {
      var deferred = $q.defer();
      api.changeUserRole(data).then(function () {
        // dispatch message
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('UPDATE_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function changePassword(data) {
      var deferred = $q.defer();
      api.changePassword(data).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('CHANGED_PASSWORD_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getAllCompanyUsers (page, pageSize, orderBy, order){
      var deferred = $q.defer();

      api.getCompanyUsers(page, pageSize, orderBy, order).then(function(data){
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteUser(userId){
      var deferred = $q.defer();

      api.deleteUser(userId).then(function(data){
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('DELETE_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function addNewUser(data){
      var deferred = $q.defer();

      api.addNewUser(data).then(function(data){
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('ADD_USER_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function forgotPassword(email, language) {
      var deferred = $q.defer();
      api.forgotPassword(email, language).then(function (data) {
        dispatcher.dispatch({
            type: ActionTypesEnum.SHOW_TOASTER_MSG,
            payload: {
              type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
              message : $translate.instant('SUCCESS_FORGOT_PASSWORD_NOTIFICATION')
            }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function activateAccount(data){
      var deferred = $q.defer();
      api.activateAccount(data).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function resetPassword(data){
      var deferred = $q.defer();
      api.resetPassword(data).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteHistory(){
      var deferred = $q.defer();
      api.deleteHistory().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getCompanyDetails(){
      var deferred = $q.defer();
      api.getCompanyDetails().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getRegionById(id){
      var deferred = $q.defer();
      api.getRegionById(id).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getOrganizationUsers (email, page, pageSize, orderBy, order){
      var deferred = $q.defer();

      api.getOrganizationUsers(email, page, pageSize, orderBy, order).then(function(data){
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function deleteOrganizationUser(userId, organizationId){
      var deferred = $q.defer();

      api.deleteOrganizationUser(userId, organizationId).then(function(data){
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('DELETE_USER_NOTIFICATION')
          }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getOrganizationUserById(userId){
      var deferred = $q.defer();

      api.getOrganizationUserById(userId).then(function(data){
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function refreshToken(token) {
      var deferred = $q.defer();
      api.refreshToken(token).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getReleaseNotes() {
      var deferred = $q.defer();
      api.getReleaseNotes().then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function resendVerificationMail(userEmail){
      var deferred = $q.defer();
      api.resendVerificationMail(userEmail).then(function(data){
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('RESEND_USER_VERIFICATION_EMAIL')
          }
        });
        deferred.resolve(data);
      }, function(errorData){
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function getTermsOfServiceDocument(isoCode, language) {
      var deferred = $q.defer();
      api.getTermsOfServiceDocument(isoCode, language).then(function (data) {
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

    function acceptTermsOfServiceDocument() {
      var deferred = $q.defer();
      api.acceptTermsOfServiceDocument().then(function (data) {
        // dispatch message
        dispatcher.dispatch({
          type: ActionTypesEnum.SHOW_TOASTER_MSG,
          payload: {
            type : ActionTypesEnum.TOAST_TYPE_NOTIFICATION,
            message : $translate.instant('ACCEPT_TERMS_AND_CONDITIONS')
          }
        });
        deferred.resolve(data);
      }, function (errorData) {
        deferred.reject(errorData);
      });

      return deferred.promise;
    }

  }
})();
